import { render, staticRenderFns } from "./blok-title.vue?vue&type=template&id=7c32e0ff"
import script from "./blok-title.vue?vue&type=script&lang=js"
export * from "./blok-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports